import React, { useEffect } from "react";
import { Outlet, useParams } from "react-router-dom";
import { ProgressSpinner } from "primereact/progressspinner";
import { useGetDashboard } from "api/api-hooks/dashboards-hooks";
import useDashboardStore from "store/dashboard-store";
import DashboardMain from "./DashboardMain";

const DashboardRoute = () => {
  const { dashboardId } = useParams();
  const { data, isLoading } = useGetDashboard(dashboardId as unknown as number);
  const { dashboard, setDashboard } = useDashboardStore(state => ({
    dashboard: state.dashboard,
    setDashboard: state.setDashboard,
  }));

  useEffect(() => {
    if (data && dashboard?.id !== data.id) {
      setDashboard(data);
    }
  }, [data, setDashboard, dashboard]);

  if (isLoading) {
    return <ProgressSpinner />;
  }

  return (
    <>
      <DashboardMain />
      <Outlet />
    </>
  );
};

export default DashboardRoute;
